import { ReloadOutlined, SyncOutlined } from "@ant-design/icons";
import { Button, Card, Space, Typography, Row, Col } from "antd";
import axios from "axios";
import { useState } from "react";

import { showErrorNotification, showSuccessNotification } from "../../../utils/notification";

const { Title } = Typography;

const CPSheetLeaderboardDash = ({ ROOT_URL }) => {
  const [reInitializing, setReInitializing] = useState(false);
  const [updating, setUpdating] = useState(false);

  //Initialize the leaderboard freshly from CP Sheet Progress of all Users. This has to be only used when the leaderboard is corrupted or server was down.
  const handleReinitializeLeaderboard = () => {
    setReInitializing(true);
    axios
      .get(`${ROOT_URL}/admin/cp-sheet/leaderboard/trigger-redis-update`)
      .then(() => {
        showSuccessNotification("Leaderboard reinitialized successfully");
        setReInitializing(false);
      })
      .catch((err) => {
        showErrorNotification(err);
        setReInitializing(false);
      })
      .finally(() => {
        setReInitializing(false);
      });
  };

  //Manually trigger leaderboard update (Same process that updates the leaderboard on UI every 30 seconds)
  const handleUpdateLeaderboard = () => {
    setUpdating(true);
    axios
      .get(`${ROOT_URL}/admin/cp-sheet/leaderboard/trigger-leaderboard-update`)
      .then(() => {
        showSuccessNotification("Leaderboard updated successfully");
        setUpdating(false);
      })
      .catch((err) => {
        showErrorNotification(err);
        setUpdating(false);
      })
      .finally(() => {
        setReInitializing(false);
      });
  };

  return (
    <Card title={<Title level={4}>CP Sheet Leaderboard Administration</Title>}>
      <Row gutter={[16, 16]} style={{ display: "flex" }}>
        <Col xs={24} md={12}>
          <Card style={{ height: "100%" }}>
            <Space
              direction="vertical"
              style={{ width: "100%", display: "flex", flexDirection: "column", height: "100%" }}
            >
              <Title level={5}>Initialize Leaderboard</Title>
              <Typography.Paragraph>
                Initialize the leaderboard freshly from CP Sheet Progress of all Users. This has to
                be only used when the leaderboard is corrupted or server was down.
              </Typography.Paragraph>
              <div style={{ textAlign: "left", marginTop: "auto" }}>
                <Button
                  type="primary"
                  danger
                  icon={<ReloadOutlined />}
                  loading={reInitializing}
                  onClick={handleReinitializeLeaderboard}
                  size="large"
                >
                  Reinitialize Leaderboard
                </Button>
              </div>
            </Space>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card style={{ height: "100%" }}>
            <Space
              direction="vertical"
              style={{ width: "100%", display: "flex", flexDirection: "column", height: "100%" }}
            >
              <Title level={5}>Update Leaderboard</Title>
              <Typography.Paragraph>
                Manually trigger leaderboard updation (Same process that updates the leaderboard on
                UI every 30 seconds).
              </Typography.Paragraph>
              <div style={{ textAlign: "left", marginTop: "auto" }}>
                <Button
                  type="primary"
                  icon={<SyncOutlined />}
                  loading={updating}
                  onClick={handleUpdateLeaderboard}
                  size="large"
                >
                  Update Leaderboard
                </Button>
              </div>
            </Space>
          </Card>
        </Col>
      </Row>
    </Card>
  );
};

export default CPSheetLeaderboardDash;
